import AccordionInnerTab from '@plugs/AccordionInner/AccordionInnerTab';
import React, { FunctionComponent, useState } from 'react';

import styles from './index.module.scss';

type Props = {
  elements;
  title;
};

const AccordionInner: FunctionComponent<Props> = (accordionInner) => {
  const [activeTab, setActiveTab] = useState(null);

  const setActiveTabID = (id): void => {
    const nid = activeTab !== id && id;

    setActiveTab(nid);
  };

  return (
    <div className={styles.root}>
      <p className={styles.title}>{accordionInner.title}</p>
      <div className={styles.accordion}>
        {accordionInner?.elements?.element?.map((element, key) => {
          return (
            <AccordionInnerTab
              key={key}
              data={element}
              activeTab={activeTab}
              onClick={(id) => setActiveTabID(id)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AccordionInner;
